import { BreakpointTrackerContext } from '@jutro/layout';
import { Loader, useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { CustomQuoteService, LoadSaveService } from 'twia-capability-quoteandbind-residential';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import { GatewayEndorsementService as EndorsementService } from 'twia-capability-gateway-policychange';
import { GatewayRenewalService as RenewalService } from 'gw-capability-gateway-policyrenewal'
import { useValidation } from '@xengage/gw-portals-validation-react';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import metadata from './PropertyDetailsPage.metadata.json5';
import styles from './PropertyDetailsPage.module.scss'
import AddressDetails from '../../components/PropertyDetails/AddressDetails/AddressDetails';
import LocationDetails from '../../components/PropertyDetails/LocationDetails/LocationDetails';
import DwellingDetails from '../../components/PropertyDetails/DwellingDetails/DwellingDetails';
import PrimaryPolicyDetails from '../../components/PropertyDetails/PrimaryPolicyDetails/PrimaryPolicyDetails';
import AddressUtil from '../../util/AddressUtil';
import TWIACleanseObjUtil from '../../util/TWIACleanseObjUtil';
import { resetElectronicPaymentData } from 'ent-capability-quoteandbind-common-react/util/ResetElectronicData';

function TWIAPropertyDetailsPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, id } = props;
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [locationAddressVM, setLocationAddressVM] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showAddressDetails, setShowAddressDetails] = useState(false);
    const [showLocationDetails, setShowLocationDetails] = useState(false);
    const [showDwellingDetails, setShowDwellingDetails] = useState(false);
    const [showPrimaryPolicyDetails, setShowPrimaryPolicyDetails] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const [yourHomeVM, setYourHomeVM] = useState(submissionVM.lobData.homeowners
        .coverables.yourHome);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [homeownersVM, setHomeOwnersVM] = useState(submissionVM.lobData.homeowners);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { showAlert } = useModal();
    const {
        initialValidation,
        onValidate
    } = useValidation(id);
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal'
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
    const isEitherChangeOrRenewal = TWIAJobHelper.isEitherRenewalOrPolicyChange(submissionVM.value);

    const copyAddressFields = (src) => (({ addressLine1, addressLine2, addressLine3, city, state, postalCode, country, county, territoryCode_TWIA }) => ({
        addressLine1,
        addressLine2,
        addressLine3,
        city,
        state,
        postalCode,
        country,
        county,
        // eslint-disable-next-line camelcase
        territoryCode_TWIA
    }))(src);

    const updateSubmissionVM = useCallback((homeVM) => {
        setYourHomeVM(homeVM);
        _.set(submissionVM, 'lobData.homeowners.coverables.yourHome', homeVM);
        _.set(submissionVM, 'baseData.policyContactDetails_TWIA[0].primaryAddress.mustStandardize_Ext', false);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const updatePolicyLocationTWIA = useCallback((result) => {
        if (result) {
            // _scope.locationCodeError = null;
            if (!result || !result.territoryCode || !result.coastalZoneType || _.isEmpty(result.availableCoastalZoneTypes)) {
                // _scope.locationCodeError = _filter('translate')('twia.quoteandbind.ho.views.ho-your-home.YourHomeAddressDetails.Territory Code.error.response');
            }

            submissionVM.value.lobData.homeowners.coverables.yourHome
                .primaryAddress_TWIA.territoryCode_TWIA = { code: result.territoryCode };
            submissionVM.value.lobData.homeowners.coverables.
                yourHome.primaryAddress_TWIA.eastOfHighway146_TWIA = null;
            submissionVM.value.lobData.homeowners.coverables.yourHome
                .availableCoastalZoneTypes_TWIA = result.availableCoastalZoneTypes;

            // eslint-disable-next-line no-underscore-dangle
            const _availableCoastalZoneTypesTWIA = result.availableCoastalZoneTypes;

            if (_availableCoastalZoneTypesTWIA && _availableCoastalZoneTypesTWIA.length === 1) {
                // eslint-disable-next-line prefer-destructuring
                submissionVM.value.lobData.homeowners.coverables.yourHome.coastalZoneType_TWIA = _availableCoastalZoneTypesTWIA[0];
            }

            setYourHomeVM(() => submissionVM.lobData.homeowners.coverables.yourHome);
            updateSubmissionVM(yourHomeVM);
            setShowAddressDetails(true);
            setShowLocationDetails(true);
            setShowDwellingDetails(true);
            setShowPrimaryPolicyDetails(true);
            setIsLoading(false);
        } else {
            setShowAddressDetails(true);
            setShowLocationDetails(true);
            setShowDwellingDetails(true);
            setShowPrimaryPolicyDetails(true);
            setIsLoading(false);
            // console.error('Invalid response for codes', result);
            // _scope.locationCodeError = _filter('translate')('twia.quoteandbind.ho.views.ho-your-home.YourHomeAddressDetails.Territory Code.error.response');
        }
    }, [submissionVM, updateSubmissionVM, yourHomeVM]);

    const updateAddress = useCallback((newAddress, force) => {
        if ((yourHomeVM.primaryAddress_TWIA.county.value !== newAddress.county.value ||
            yourHomeVM.primaryAddress_TWIA.city.value !== newAddress.city.value ||
            yourHomeVM.primaryAddress_TWIA.postalCode.value !== newAddress.postalCode.value)
            || force) {
            if (
                newAddress.county.aspects.valid && newAddress.county.aspects.subtreeValid &&
                newAddress.city.aspects.valid && newAddress.city.aspects.subtreeValid &&
                newAddress.postalCode.aspects.valid && newAddress.postalCode.aspects.subtreeValid
            ) {
                const reqVM = viewModelService.create({}, 'pc',
                    'org.twia.edge.capabilities.quote.submission.dto.LocationCodesRequestDTO');

                AddressUtil.createRequestData(submissionVM, reqVM,
                    newAddress.value, translator);

                if (reqVM.aspects.valid && reqVM.aspects.subtreeValid) {
                    CustomQuoteService.applyCodes(reqVM.value, authHeader).then(result => {
                        if (result) {
                            AddressUtil.fillPrimaryAddressDetails(yourHomeVM.primaryAddress_TWIA,
                                newAddress.value, translator);
                            updateSubmissionVM(yourHomeVM);
                            updatePolicyLocationTWIA(result);
                        } else {
                            setShowAddressDetails(true);
                            setShowLocationDetails(true);
                            setShowDwellingDetails(true);
                            setShowPrimaryPolicyDetails(true);
                            setIsLoading(false);
                            // _scope.locationError = _filter('translate')('twia.quoteandbind.ho.views.ho-your-home.YourHomeAddressDetails.Territory Code.error.response');
                        }
                    }).catch(e => {
                        setIsLoading(false);
                    });
                } else {
                    setShowAddressDetails(true);
                    setShowLocationDetails(true);
                    setShowDwellingDetails(true);
                    setShowPrimaryPolicyDetails(true);
                    setIsLoading(false);
                }
            } else {
                setShowAddressDetails(true);
                setShowLocationDetails(true);
                setShowDwellingDetails(true);
                setShowPrimaryPolicyDetails(true);
                setIsLoading(false);
            }
        }
    }, [authHeader, submissionVM, translator, updatePolicyLocationTWIA,
        updateSubmissionVM, viewModelService, yourHomeVM]);

    const priAddressDetails = useCallback(() => {
        const address = {};

        if (submissionVM.value.lobData.homeowners.coverables.yourHome === undefined
            || submissionVM.value.lobData.homeowners.coverables.yourHome.primaryAddress_TWIA === undefined) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM.value, 'lobData.homeowners.coverables.yourHome.primaryAddress_TWIA', {});

            const defaultHOLocation = submissionVM.lobData.homeowners.dwellingLocation_TWIA.value;

            ['addressLine1', 'addressLine2', 'addressLine3', 'country', 'state', 'county',
                'postalCode', 'city', 'territoryCode_TWIA'].forEach(item => {
                    // eslint-disable-next-line security/detect-object-injection
                    if (!address[item]) {
                        // eslint-disable-next-line security/detect-object-injection
                        address[item] = defaultHOLocation[item]
                    }
                });

            if (!address.territoryCode_TWIA || !address.territoryCode_TWIA.code) {
                address.territoryCode_TWIA = {
                    code: null
                };
            }

            submissionVM.value.lobData.homeowners.coverables.yourHome.primaryAddress_TWIA = address;
            setYourHomeVM(submissionVM.lobData.homeowners.coverables.yourHome); // DE15663
            updateWizardData(submissionVM);
        }

        const primaryAddressTWIA = yourHomeVM.primaryAddress_TWIA;

        if (!primaryAddressTWIA.county.value) {
            const accountHolderAddress = submissionVM.baseData.accountHolder.primaryAddress.value;
            const addressNew = copyAddressFields(accountHolderAddress);

            if (!addressNew.territoryCode_TWIA || !addressNew.territoryCode_TWIA.code) {
                addressNew.territoryCode_TWIA = {
                    code: null
                };
            }

            primaryAddressTWIA.value = addressNew;
            _.set(yourHomeVM, 'primaryAddress_TWIA', primaryAddressTWIA);
            updateSubmissionVM(yourHomeVM);
        }

        const locAddressVM = viewModelService.create(
            {},
            'pc', 'edge.capabilities.address.dto.TWIAPropertyAddressDTO',
            { 'AdditionalAddressesSet': true });

        AddressUtil.fillLocationAddressDetails(locAddressVM,
            yourHomeVM.primaryAddress_TWIA.value, translator);
        setLocationAddressVM(locAddressVM);

        if (!yourHomeVM.primaryAddress_TWIA.territoryCode_TWIA.code ||
            !yourHomeVM.primaryAddress_TWIA.territoryCode_TWIA.code.value ||
            !yourHomeVM.coastalZoneType_TWIA.value
        ) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(yourHomeVM, 'primaryAddress_TWIA.territoryCode_TWIA.value', { code: '' });
            updateSubmissionVM(yourHomeVM);
            updateAddress(locAddressVM, true);
        } else {
            setShowAddressDetails(true);
            setShowLocationDetails(true);
            setShowDwellingDetails(true);
            setShowPrimaryPolicyDetails(true);
            setIsLoading(false);
        }
    }, [submissionVM, translator, updateAddress, updateSubmissionVM,
        updateWizardData, viewModelService, yourHomeVM]);

    const updateLocationVM = useCallback((addressVM, isUpdate) => {
        setLocationAddressVM(() => addressVM);

        if (isUpdate) {
            updateAddress(addressVM)
        }
    }, [updateAddress]);

    useEffect(() => {
        setIsLoading(true);
        // US26300
        TWIACleanseObjUtil.resetAspectsNotVisibleValues(submissionVM.lobData.homeowners
            .coverables.yourHome);
        priAddressDetails();
    }, [])

    const validateCompanion = useCallback(() =>
        // eslint-disable-next-line no-secrets/no-secrets
        _.get(yourHomeVM, 'haveCompanionPolicy_TWIA.aspects.required') === true,
        [yourHomeVM]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        addressDetailsAccordion: {
            visible: showAddressDetails,
            errorState: _.includes(invalidComponent, 'AddressDetails') && showErrors
        },
        addressDetailsSection: {
            yourHomeVM,
            updateSubmissionVM,
            updateLocationVM,
            updateAddress,
            locationAddressVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            isEitherChangeOrRenewal
        },
        locationDetailsAccordion: {
            visible: showLocationDetails,
            errorState: _.includes(invalidComponent, 'LocationDetails') && showErrors
        },
        locationDetailsSection: {
            yourHomeVM,
            updateSubmissionVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            isEitherChangeOrRenewal
        },
        dwellingDetailsAccordion: {
            visible: showDwellingDetails,
            errorState: _.includes(invalidComponent, 'DwellingDetails') && showErrors
        },
        dwellingDetailsSection: {
            yourHomeVM,
            homeownersVM,
            updateSubmissionVM,
            showErrors,
            findInvalidComponent,
            onValidate,
            isEitherChangeOrRenewal
        },
        priPolicyDetailsAccordion: {
            visible: showPrimaryPolicyDetails && validateCompanion(),
            errorState: _.includes(invalidComponent, 'PrimaryPolicyDetails') && showErrors
        },
        priPolicyDetailsSection: {
            yourHomeVM,
            updateSubmissionVM,
            submissionVM,
            showErrors,
            findInvalidComponent,
            onValidate
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        accordionBreak: {
            visible: showErrorMessage
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addressDetailsComponent: AddressDetails,
            locationDetailsComponent: LocationDetails,
            dwellingDetailsComponent: DwellingDetails,
            priPolicyDetailsComponent: PrimaryPolicyDetails
        }
    };

    const onNext = useCallback(async () => {

        if (invalidComponent.length > 0) {
            setShowErrors(true)
            
            return false;
        }

        setShowErrors(false);

        try {
            const newSubmissionVM = viewModelService.clone(submissionVM);

            // US26300
            TWIACleanseObjUtil.resetAspectsNotVisibleValues(newSubmissionVM);
            resetElectronicPaymentData(submissionVM, updateWizardData)

            if (!isRenewal && !isPolicyChange) {
                _.set(newSubmissionVM, 'lobData.homeowners.coverables.construction', undefined);
                _.set(newSubmissionVM, 'lobData.homeowners.offerings', undefined);
            }

            // DE15482 DE15731
            if (!validateCompanion()) {
                if (!_.get(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.haveReplacemntCstCov_TWIA.aspects.required')) {
                    _.set(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.haveReplacemntCstCov_TWIA.value', undefined);
                }

                if (!_.get(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needAdditinlLivExpCov_TWIA.aspects.required')) {
                    _.set(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needAdditinlLivExpCov_TWIA.value', undefined);
                }

                if (!_.get(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needConsequentlLosCov_TWIA.aspects.required')) {
                    _.set(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needConsequentlLosCov_TWIA.value', undefined);
                }

                if (!_.get(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needWindDrivenRainCov_TWIA.aspects.required')) {
                    _.set(newSubmissionVM, 'lobData.homeowners.coverables.yourHome.needWindDrivenRainCov_TWIA.value', undefined);
                }
            }

            if (isRenewal) {
                submissionVM.value = await RenewalService.saveRenewal(
                    newSubmissionVM.value,
                    authHeader
                )
            } else if(isPolicyChange){
                submissionVM.value = await EndorsementService.saveAndQuoteSubmission(
                    [newSubmissionVM.value],
                    authHeader
                )
            } else {
                submissionVM.value = await LoadSaveService.updatePropertyDetailsAndSubmission(
                    newSubmissionVM.value,
                    authHeader
                )
            }

            updateWizardData(submissionVM);

            const { validationIssues } = submissionVM.value.errorsAndWarnings;

            if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0) {
                if (validationIssues.issues[0].flowStepId === "HomeownersDwelling") {
                    setShowErrorMessage(true);
                    setShowErrorDescription(validationIssues.issues[0].reason);

                    return false;
                }
            }

            if (validationIssues && validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0) {
                const fieldIssueProperty = _.find(validationIssues.fieldIssues, (field) => field
                    .flowStepId === "HomeownersDwelling");

                if (fieldIssueProperty) {
                    setShowErrorMessage(true);
                    setShowErrorDescription(fieldIssueProperty.reason);

                    return false;
                }
            }

            return submissionVM
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);

            return false;
        }
    }, [authHeader, invalidComponent, isPolicyChange, isRenewal, showAlert, submissionVM,
        updateWizardData, validateCompanion, viewModelService]);

    // DE17587, DE18778
    const skip = useCallback(async vm => {
        const ppStatus = _.get(submissionVM.value, 'baseData.periodStatus') 
        || _.get(submissionVM.value, 'status');

        return (ppStatus === 'Quoted' || ppStatus === 'Renewing');
    }, [submissionVM]);

    return (
        <WizardPage
            id={id}
            onNext={onNext}
            skipWhen={skip}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIAPropertyDetailsPage.propTypes = wizardProps;
export default TWIAPropertyDetailsPage;
